import React from 'react'

import './style.css'


export default class extends React.Component  {
  constructor(props) {
    super(props);
    this.state = {
      questionText: this.props.questionText,
      selected: -1
    }
    this.props = props;
    this.chooseVal = this.chooseVal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selected: (nextProps.reverseScore)?2-nextProps.currentAnswer:nextProps.currentAnswer
    })
  }

  componentWillMount() {
    this.setState({
      selected: (this.props.reverseScore)?2-this.props.currentAnswer:this.props.currentAnswer
    })
  }
  chooseVal(v) {
    this.setState({
      selected: v
    });
  }
  render() {

      var bClasses = {
        selected: "btn btn-primary active",
        notSelected: "btn btn-primary"
      };
      return (
        <div >
          <p className="question">
            {this.props.questionText}
            <div className="btn-group-vertical btn-block choices" >
              <button type="button"
                id='never-btn'
                className={(this.state.selected === 0)?bClasses.selected:bClasses.notSelected}
                onClick={() => {
                  this.chooseVal(0)
                }}>Never</button>
              <button type="button"
                id='sometimes-btn'
                className={(this.state.selected === 1)?bClasses.selected:bClasses.notSelected}
                onClick={() => {
                  this.chooseVal(1)
                }}>Sometimes</button>
              <button type="button"
                id='always-btn'
                className={(this.state.selected === 2)?bClasses.selected:bClasses.notSelected}
                onClick={() => {
                  this.chooseVal(2)
                }}>Always</button>
            </div>
          </p>
          <button className={"next-question-button btn btn-block btn-success"}
            disabled={(this.state.selected === -1)}
            onClick={() => {
              if(this.state.selected !== -1) {
                var x = (this.props.reverseScore)?2-this.state.selected:this.state.selected;
                this.props.onAnswer(x);
              }
          }}>Next »</button>
        </div>
      )

  }
}



// WEBPACK FOOTER //
// ./src/components/Quiz/Question.js